<template>
  <div class="container" id="about">
    <h1>This is an about page</h1>
    <p>
      Carixin is the industry leader in mobile vehicle repair, maintenance,
      and inspection, offering 500+ services to consumers and fleets across the
      U.S. and Canada. Our mission is to leverage technology to service any
      vehicle, any place, any time. We’ve built the mobility platform of the
      future, enabling us to service vehicles at the point of need, increase
      asset yield, and lower total cost. Our mobile model and cloud-based
      platform replace shops’ physical infrastructure – allowing us to charge
      fleet owners less, pay more than shops, and attract top-tier mechanics and
      ASE-certified technicians. Above all, we value our customers’ happiness
      and satisfaction, whether we’re changing the brakes on a family’s minivan
      or enabling a commercial fleet of 3,000 to increase utilization. With more
      than 1.3 million vehicles on the platform and one of the highest Net
      Promoter Scores in the business, we’re speeding towards our vision to
      enable quality auto services for any vehicle, any place, any time.
    </p>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>